import { useEffect, useState } from 'react';

import Button from '@/components/shared/Button/Button';
import Paper from '@/components/shared/Paper/Paper';
import { Text } from '@/components/shared/Text/Text';
import { SessionStatus } from '@/lib/types/session-status';
import { countSessionsByType } from '@/lib/utils/sessions';
import { SessionHub } from '@addmile/backend-client';

import AddSessionModal from '../../AddSessionModal/AddSessionModal';

interface SessionsInfoProps {
  sessions: SessionHub[];
}

const SessionInfo = ({ sessions }: SessionsInfoProps) => {
  const { New, Booked, Completed, Skipped } = countSessionsByType(sessions, SessionStatus);
  const [availableSessions, setAvailableSessions] = useState<number>(New);
  const [showModal, setShowModal] = useState(false);

  const closePopup = () => {
    setShowModal(false);
  };

  useEffect(() => {
    setAvailableSessions(New);
  }, [New, sessions.length]);

  return (
    <>
      <Paper className="justify-start h-full w-[375px]">
        <div className="flex justify-between items-center gap-2">
          <Text.Bigger weight="bold">Sessions</Text.Bigger>
          <div className="flex justify-start items-center gap-2">
            <Button
              size="s"
              className="w-[72px]"
              prefixIcon={<img className="w-6" src="/icons/plus_outline.svg" />}
              label="Add"
              onClick={() => setShowModal(true)}
            />
          </div>
        </div>
        <div className="bg-primary-10 rounded-lg border-primary-10 flex justify-between py-2 px-3 items-center mt-5">
          <Text.Normal weight="bold">Available for booking:</Text.Normal>
          <div className="bg-white-100 rounded-lg py-2 px-4 font-bold text-2xl">
            {availableSessions}
          </div>
        </div>
        <div className="mt-4 flex items-center justify-between font-bold pb-2">
          <Text.Normal weight="bold">Booked:</Text.Normal>
          <span className="mr-16 text-lg font-medium">{Booked}</span>
        </div>
        <div className="flex items-center justify-between font-bold border-t border-neutral-10 pt-2">
          <Text.Normal weight="bold">Completed:</Text.Normal>
          <span className="mr-16 text-lg font-medium">{Completed}</span>
        </div>
        <div className="flex items-center justify-between font-bold border-t border-neutral-10 pt-2">
          <Text.Normal weight="bold">Skipped:</Text.Normal>
          <span className="mr-16 text-lg font-medium">{Skipped}</span>
        </div>
      </Paper>

      <AddSessionModal
        isPopupOpen={showModal}
        closePopup={closePopup}
        setAvailableSessions={setAvailableSessions}
      />
    </>
  );
};

export default SessionInfo;
